import customAxios from "lib/axios";

const PUSH_EVENTS_BASE = "/notifications/push/events";

export type NotificationCenterItem = {
  id: number;
  eventUuid: string;
  eventType: string;
  title: string | null;
  body: string | null;
  targetUrl: string | null;
  providerStatus: string | null;
  sentAt: string | null;
  deliveredAt: string | null;
  openedAt: string | null;
  readAt: string | null;
  dismissedAt?: string | null;
  createdAt: string | null;
  isRead: boolean;
};

export const fetchUnreadNotificationsCount = async () => {
  const { data } = await customAxios.get(`${PUSH_EVENTS_BASE}/unread-count`);
  return Number(data?.unreadCount || 0);
};

export const fetchNotificationCenterItems = async (limit = 20) => {
  const { data } = await customAxios.get(PUSH_EVENTS_BASE, {
    params: { limit },
  });
  return (data?.items || []) as NotificationCenterItem[];
};

export const markNotificationAsRead = async (id: number) => {
  await customAxios.post(`${PUSH_EVENTS_BASE}/${id}/read`);
};

export const markAllNotificationsAsRead = async () => {
  await customAxios.post(`${PUSH_EVENTS_BASE}/read-all`);
};

export const dismissNotification = async (id: number) => {
  await customAxios.post(`${PUSH_EVENTS_BASE}/${id}/dismiss`);
};
